import React, { useEffect } from "react";
import { Grid, Button, Typography, Container, Link } from "@mui/material";
import jsonData from "./createaccountoptionsconfig.json";
import MailIcon from "@mui/icons-material/Mail";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import GoogleIcon from "@mui/icons-material/Google";
import AppleIcon from "@mui/icons-material/Apple";
import FacebookIcon from "@mui/icons-material/Facebook";

const CreateAccountOptions = ({ setShowAppBar }) => {
  const navigate = useNavigate();

  React.useLayoutEffect(() => {
    setShowAppBar(false);
    return () => {
      setShowAppBar(true);
    };
  }, [setShowAppBar]);

  const handleBack = () => navigate(-1);
  const handleLoginClick = () => navigate("/loginpage");
  const handleButtonClick = (buttonLabel) => {
    if (buttonLabel === "Continue with Email") {
      navigate("/Createaccountform");
    }
  };

  return (
    <Grid container sx={{ height: "100vh", padding: 2 }}>
      {/* Top Buttons */}
      <Grid
        container
        item
        justifyContent="space-between"
        alignItems="center"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          padding: 2,
        }}
      >
        {/* Back Button */}
        <Grid item>
          <Button
            color="primary"
            startIcon={<ArrowBackIosNewIcon />}
            onClick={handleBack}
            sx={{
              textTransform: "uppercase",
            }}
          >
            Back
          </Button>
        </Grid>

        {/* Login Button */}
        <Grid item>
          <Button
            color="primary"
            onClick={handleLoginClick}
            sx={{
              textTransform: "uppercase",
            }}
          >
            Login
          </Button>
        </Grid>
      </Grid>

      {/* Main Content */}
      <Grid
        container
        item
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ height: "100%", textAlign: "center", gap: 4 }}
      >
        {/* Title and Description */}
        <Grid item>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", mb: 1 }}
            gutterBottom
          >
            {jsonData.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {jsonData.description}
          </Typography>
        </Grid>

        {/* Legal Text */}
        <Grid item>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: "0.75rem",
              maxWidth: "350px",
              lineHeight: 1.5,
              margin: "0 auto",
            }}
          >
            {jsonData.legalText}{" "}
            <Link href="/terms" underline="hover">
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link href="/privacy" underline="hover">
              Privacy Policy
            </Link>
            .
          </Typography>
        </Grid>

        {/* Social Sign-Up Buttons */}
        <Grid container item direction="column" alignItems="center" spacing={1}>
          {jsonData.buttons.map((button, index) => (
            <Grid item key={index} sx={{ width: "100%", maxWidth: "300px" }}>
              <Button
                variant={
                  button.style === "social-button" ? "outlined" : "contained"
                }
                onClick={() => handleButtonClick(button.label)}
                startIcon={
                  button.icon === "google" ? (
                    <GoogleIcon />
                  ) : button.icon === "apple" ? (
                    <AppleIcon />
                  ) : button.icon === "facebook" ? (
                    <FacebookIcon />
                  ) : button.icon === "email" ? (
                    <MailIcon />
                  ) : null
                }
                sx={{
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 4,
                  padding: "8px 16px",
                  width: "100%", // Auto width based on content
                  maxWidth: "300px", // Optional: Add a max width
                  margin: "0 auto", // Center the button horizontally
                  borderRadius: 1,
                  borderColor: "#ccc",
                  "&:hover": {
                    backgroundColor: "#f1f1f1",
                  },
                }}
              >
                {button.label}
              </Button>
            </Grid>
          ))}
        </Grid>

        {/* reCAPTCHA message */}
        {jsonData.recaptcha && (
          <Grid item>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontSize: "0.65rem",
                lineHeight: 1.5,
                maxWidth: "400px",
                margin: "0 auto",
              }}
            >
              {jsonData.recaptchaText}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default CreateAccountOptions;
